import { Link, useLocation } from "react-router-dom";
import { React, useState } from "react";
import AddFunds from "../../addFunds/addFunds.component";
import { CMLi } from "./menu-item.styles";

const MenuItem = ({ children, className, ...props }) => {
  const location = useLocation();
  const { content, link, subMenu } = props.link;
  const [status, setStatus] = useState();
  const [modalOpen, setModalOpen] = useState();
  const [verificarionOpen,setVerificarionOpen] = useState(false);

  const handleOpen = (status) => {
    setStatus(status);
    setModalOpen(true);
  };

  const isExternalLink = (url) => /^https?:\/\//.test(url);

  return (
    <CMLi
      {...props}
      className={`${className}${link && !isExternalLink(link) && link === "auctions-board"
      ? (location.pathname.startsWith("/auctions-board") || location.pathname.startsWith("/private-auction-board")) 
        ? " active" 
        : ""
      : location.pathname.includes(link) 
        ? " active" 
        : ""
        }${subMenu ? " submenu-container" : content ? " menucontent-container" : ""}`}
    >
      {content ? (
        <>
          {children}
          <div className="submenu custom-submenu">
            {content}
          </div>
        </>
      ) : !subMenu ? (
        isExternalLink(link) ? (
          <a href={link} rel="noopener noreferrer">
            {children}
          </a>
        ) : (
          <Link to={link}>{children}</Link>
        )
      ) : (
        <>
          {children}
          <ul className="submenu custom-submenu">
            {subMenu.map((subItem, idx) => {
              const Icon = subItem.icon;
              return (
                <MenuItem
                  key={idx}
                  link={subItem}
                  className={`${idx === subMenu.length - 1 ? "dotted-border" : ""}`}
                >
                  {subItem.description === 'Add Funds' ? (
                    <li onClick={() => handleOpen('Add')}>
                      <Icon
                        width={32}
                        height={32}
                        className={`${subItem.hideDesktop ? "hide-lg" : ""}`}
                        style={{ marginRight: '20px' }}
                      />
                      {subItem.description}
                    </li>
                  ) : (
                    <li onClick={subItem.onClick}>
                      <Icon
                        width={32}
                        height={32}
                        className={`${subItem.hideDesktop ? "hide-lg" : ""}`}
                        style={{ marginRight: '20px' }}
                      />
                      {subItem.description}
                    </li>
                  )}
                </MenuItem>
              );
            })}
          </ul>
        </>
      )}
      {modalOpen &&
        <AddFunds success={false} handleOpen={modalOpen} setHandleOpen={setModalOpen} status={status} setVerificarionOpen={setVerificarionOpen}/>
      }
    </CMLi>
  );
};

export default MenuItem;
